module.exports = __webpack_public_path__ + "static/Jost-Regular-e19e7a50ae92b2d975c91416a37efbef.woff2";